// extracted by mini-css-extract-plugin
export default {"stripeformcontainer":"stripe_payment_stripeformcontainer__3xahC","StripeElement":"stripe_payment_StripeElement__o0P8P","btns":"stripe_payment_btns__W2ood"};